export const TABLE_NAMES = {
  FEEDBACK_LINKS: 'ti-feedback-links',
  VOTE_LINKS: 'ti-votes',
};
